import { render } from "./UploadPackingList.vue?vue&type=template&id=5d0238ef"
import script from "./UploadPackingList.vue?vue&type=script&lang=js"
export * from "./UploadPackingList.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/agro_exporter/production/uniq_final_packing_list/upload_packing_list.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fagro_exporter%2Fproduction%2Funiq_final_packing_list%2FUploadPackingList.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__